import { handleActions } from 'redux-actions';
import { defaultUsernameRenameWidgetState } from './defaults';
import { UsernameRenameWidgetData } from './types';
import { initMyAccountPage } from '../../actions';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  saveRequestMetaReducer,
} from '../utils';
import {
  setUsernameRenameWidgetPassword,
  setUsernameRenameWidgetUsername,
  saveUsernameRename,
  saveUsernameRenameSuccess,
  saveUsernameRenameFailure,
} from './actions';
import { NetworkRequestState } from '../baseTypes';

const mergeUsernameRenameWidgetDataChange =
  makeSpecificSaveableWidgetDataMergeFunction(
    defaultUsernameRenameWidgetState,
    widgetState => {
      return (
        widgetState.currentData.username !== widgetState.initialData.username
      );
    }
  );

export default handleActions<UsernameRenameWidgetData, any>(
  {
    [initMyAccountPage.toString()]: (
      state,
      action: ReturnType<typeof initMyAccountPage>
    ) => {
      const personalInformationData: UsernameRenameWidgetData['initialData'] = {
        username: action.payload.data.session.user.username ?? '',
        password: '',
        isRenameEligible: action.payload.data.usernameRename?.isRenameEligible,
        hasRecentRename: action.payload.data.usernameRename?.hasRecentRename,
      };
      return {
        initialData: personalInformationData,
        currentData: personalInformationData,
        isDirty: false,
        saveRequest: {
          status: NetworkRequestState.IDLE,
        },
      };
    },
    [setUsernameRenameWidgetUsername.toString()]: (
      state,
      action: ReturnType<typeof setUsernameRenameWidgetUsername>
    ) =>
      mergeUsernameRenameWidgetDataChange(state, {
        username: action.payload.username,
      }),
    [setUsernameRenameWidgetPassword.toString()]: (
      state,
      action: ReturnType<typeof setUsernameRenameWidgetPassword>
    ) =>
      mergeUsernameRenameWidgetDataChange(state, {
        password: action.payload.password,
      }),
    ...saveRequestMetaReducer({
      initialAction: saveUsernameRename,
      successAction: saveUsernameRenameSuccess,
      failureAction: saveUsernameRenameFailure,
    }),
  },
  defaultUsernameRenameWidgetState
);
